import {AuwContactBox} from "./AuwContactBox";


if($('.contact-box').length) {
    $.each($('.contact-box'),function(i,e) {
        new AuwContactBox($(e));
    });
}



